Ext.define('SA.EditPanelDisabledSectionsController', {
    constructor(sections) {
        this.sections = sections;
    },

    eachItem(callback) {
        this.sections.forEach(section => section.eachItem(callback));
    },

    getSectionById(sectionId) {
        return this.sections.find(section => section.hasSectionId(sectionId));
    },

    getViews() {
        return this.sections.map(section => section.getView());
    },

    setIds(ids) {
        this.sections[0].setIds(ids);
    }
});